import styled, { css } from 'styled-components'
import { InfoWindow } from '@react-google-maps/api'

import Link from '../Link'

export const WindowInfo = styled(InfoWindow)``

export const WindowInfoWrapper = styled.div``

export const WindowInfoTitle = styled.h4`
  margin: 0 0 1rem 0;
  ${({ theme }) => theme.textStyles.montserratTextBaseBold};
`

const paragraphStyle = css`
  ${({ theme }) => theme.textStyles.montserratSmMedium};
  ${({ theme }) => theme.colors.blueSecondaryBis};
`

export const WindowInfoAddress = styled.p`
  ${paragraphStyle};
`
export const WindowInfoCategory = styled.p`
  ${paragraphStyle};
`
export const WindowInfoPublicationDate = styled.p`
  ${paragraphStyle};
  margin-top: 1rem;
`

export const ReadMoreLink = styled(Link)`
  ${({ theme }) => theme.textStyles.montserratSmMedium};
  display: block;
  margin-left: auto;
  margin-top: 2rem;
  width: max-content;
  border-bottom: 1px solid;
  padding-bottom: 0.5rem ${({ theme }) => theme.colors.blueSecondary};
  color: ${({ theme }) => theme.colors.blueSecondary};
`
